import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgClockPlus = function SvgClockPlus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    className: "Icon ".concat((props === null || props === void 0 ? void 0 : props.className) || ''),
    ref: ref
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M11 21a8.8 8.8 0 0 1-3.512-.7 9 9 0 0 1-2.863-1.925A9 9 0 0 1 2.7 15.512 8.8 8.8 0 0 1 2 12q0-1.874.7-3.512a9 9 0 0 1 1.925-2.863A9 9 0 0 1 7.488 3.7 8.8 8.8 0 0 1 11 3a8 8 0 0 1 2 .25V5.3a7 7 0 0 0-.988-.225A7 7 0 0 0 11 5Q8.05 5 6.025 7.025T4 12t2.025 4.975T11 19t4.975-2.025T18 12q0-.275-.025-.5a7 7 0 0 0-.075-.5h2.05q.05.275.05.5v.5a8.8 8.8 0 0 1-.7 3.512 9 9 0 0 1-1.925 2.863 9 9 0 0 1-2.863 1.925A8.8 8.8 0 0 1 11 21m2.8-4.8L10 12.4V7h2v4.6l3.2 3.2zM18 9V6h-3V4h3V1h2v3h3v2h-3v3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClockPlus);

export { ForwardRef as default };
